import { TrackEnum } from "@selector/shared/openapi";
import { colors } from "widgets/utils";

import type { TrackType } from "../../types.ts";

export const getColorByTrackType = (trackType: TrackType): string => {
  return ColorByTrackType[trackType] ?? colors.fadedOrangeLight;
};

export const ColorByTrackType: Partial<Record<TrackType, string>> = {
  [TrackEnum.PROTEIN_LOCATION]: colors.dangerPale,
  [TrackEnum.GENE]: colors.paleTealLight,
  [TrackEnum.TRANSCRIPT_LOCATION]: colors.fadedOrangeLight,
  [TrackEnum.NUCLEOTIDE_FEATURE]: colors.blueBerryLight,
};
